import { render, staticRenderFns } from "./MetricsByArea.vue?vue&type=template&id=65d0c22f"
import script from "./MetricsByArea.vue?vue&type=script&lang=js"
export * from "./MetricsByArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports